export default __webpack_public_path__ + "static/media/assessment_glide_4_1.6bce9001.svg";